import axios from 'axios'
// 产品列表接口
export const getProductList = () => {
  return axios.get('/api/users/shops/list')
}

// 产品详情接口
export const getProductDetail = (id) => {
  return axios.get('/api/users/shops/'+id)
}

// 联系我们接口
export const contactUs = (data) => {
  return axios.post('/api/users/shops/submitForm', data)
}
